import React, { useState, useEffect, useRef } from 'react';
import { Container, Grid, Paper } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
const CustomContainer = HOCLoader(Container);

export const EzyPayAEPSLogin = () => {
    const formRef = useRef(null);
    const location = useLocation();
    const classes = commonStyle();
    const LoginURL = location.state.LoginURL;
    const SessionID = location.state.SessionID;
    const [Status, setStatus] = useState('PROCESS');
    const initialValues = {
        LoginURL: LoginURL,
        SessionID: SessionID
    };

    const [FormObj] = useState(initialValues);

    useEffect(() => {
        formRef.current.submit();
    }, []);

    useEffect(() => {
        let URL = window.location.pathname;
        var res = URL.split('/');
        let Status = res[res.length - 1];
        if (Status !== 'EzyPayAEPSLogin') setStatus(Status);
    }, []);

    return (
        <CustomContainer>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <h2 className={classes.PaperHead_h2}>
                        Transaction Status: {Status}
                    </h2>
                </Grid>
            </Grid>

            <form
                ref={formRef}
                id="form1"
                method="post"
                name="form1"
                action={FormObj.LoginURL}
                target="_blank"
            >
                <input
                    type="hidden"
                    name="sessionid"
                    value={FormObj.SessionID}
                />
            </form>
        </CustomContainer>
    );
};
